import clsx from 'clsx';
import { FC, Fragment, useState } from 'react';
import { AddMeta } from '@/views/SignUp/components/Verification/Steps/AddMeta';
import { HostedQuestion } from '@/views/SignUp/components/Verification/Steps/HostedQuestion';
import { useSubmitKYB } from '@/api/queryHooks/useKYBController';
import { Button, PopoverWithTrigger } from '@/components/common';
import { BankStatement, ChooseUrl, CompanyExtract, Pending, UploadLogo } from './Steps';
import styles from './Verification.module.css';

const PROGRESS = [
  // 'Identity Verification',
  'Company Extract',
  'Bank Statement',
  'Upload Logo',
  'Meta Information',
  'Choose URL',
  '',
];

interface VerificationProps {
  onCompleteKYB?: () => void;
}

export const Verification: FC<VerificationProps> = ({ onCompleteKYB }) => {
  const [step, setStep] = useState(1);
  const { mutateAsync: submitKYB } = useSubmitKYB({
    onSuccess: () => {
      if (onCompleteKYB) {
        onCompleteKYB();
      }
    },
  });
  const renderStep = (step: number) => {
    switch (step) {
      // case 0:
      //   return <IdentityVerification setStep={setStep} />;
      case 1:
        return <CompanyExtract setStep={setStep} />;
      case 2:
        return <BankStatement setStep={setStep} />;
      case 3:
        return <UploadLogo setStep={setStep} />;
      case 4:
        return <AddMeta setStep={setStep} />;
      case 5:
        return <ChooseUrl finish={finish} />;
      case 6:
        return <HostedQuestion setStep={setStep} finish={finish} />;
      default:
        return null;
    }
  };

  function finish() {
    submitKYB();
    setStep(999); // any big number, bigger than PROGRESS length
  }

  return step <= PROGRESS.length ? (
    <div className={styles.main}>
      <ul className={styles.progressList}>
        {PROGRESS.map((item, i) => {
          return (
            <Fragment key={item}>
              <li key={item} className={clsx(styles.progressItem, { [styles.activeProgressItem]: step === i + 1 })}>
                {item}
                {(item === PROGRESS[0] || item === PROGRESS[1]) && (
                  <div className={styles.popoverWrapper}>
                    <PopoverWithTrigger
                      offset={2}
                      width={185}
                      placement="bottom left"
                      renderTrigger={({ state, triggerProps, triggerRef }) => {
                        return (
                          <Button
                            {...triggerProps}
                            className={styles.popoverWrapper}
                            iconClassName={clsx(
                              styles.popoverWrapperIcon,
                              i + 1 === step && styles.popoverWrapperIconActive,
                            )}
                            iconPosition="right"
                            variants="subtle"
                            size="mediumSubtle"
                            icon={'infoCircled'}
                            buttonRef={triggerRef}
                            onPress={state.open}
                            navigationTab
                          />
                        );
                      }}
                    >
                      <div className={styles.popoverInfo}>
                        {item === PROGRESS[0] && 'The ASIC document showing the directors of your company.'}

                        {item === PROGRESS[1] && 'To confirm banking details'}
                      </div>
                    </PopoverWithTrigger>
                  </div>
                )}
              </li>
              {i === 1 && <hr className={styles.progressDivider} />}
            </Fragment>
          );
        })}
      </ul>
      <div className={styles.stepsWrapper}>{renderStep(step)}</div>
    </div>
  ) : (
    <Pending />
  );
};
